const select = (parent, className) =>
  parent.getElementsByClassName(className) || [];

export const selectOne = (parent, className) => select(parent, className)[0] || null;

export default select;



// WEBPACK FOOTER //
// ./src/lib/dom/select-by-class.js